export class AttributeHandlerService {
  static forElement(element: Element) {
    return new SingleElementAttributeHandler(element);
  }

  static forElements(elements: Element[]) {
    return new MultipleElementAttributeHandler(elements);
  }
}

class BaseAttributeHandler {
  static setInert(isInert: boolean, el: Element): void {
    if (isInert) el.setAttribute('inert', '');
    else el.removeAttribute('inert');
  }

  static setAriaHidden(isHidden: boolean, el: Element): void {
    if (isHidden) el.setAttribute('aria-hidden', 'true');
    else el.removeAttribute('aria-hidden');
  }
}

class SingleElementAttributeHandler implements ISingleElementHandler {
  constructor(private element: Element) {}

  setInert(isInert: boolean) {
    BaseAttributeHandler.setInert(isInert, this.element);
    return this;
  }

  setAriaHidden(isHidden: boolean) {
    BaseAttributeHandler.setAriaHidden(isHidden, this.element);
    return this;
  }

  setFocus(shouldFocus = true) {
    const element = this.element as HTMLElement;
    shouldFocus ? element.focus() : element.blur();
    return this;
  }
}

class MultipleElementAttributeHandler implements IMultipleElementHandler {
  constructor(private elements: Element[]) {}

  setInert(isInert: boolean) {
    this.elements.forEach(el => BaseAttributeHandler.setInert(isInert, el));
    return this;
  }

  setAriaHidden(isHidden: boolean) {
    this.elements.forEach(el => BaseAttributeHandler.setAriaHidden(isHidden, el));
    return this;
  }
}

interface IAttributeHandler {
  /**
   * Sets the inert attribute on the element(s).
   * @param isInert If true, sets the inert attribute on the element(s).
   * If false, removes the inert attribute.
   */
  setInert(isInert: boolean): this;

  /**
   * Sets the aria-hidden attribute on the element(s).
   * @param isHidden If true, sets the aria-hidden attribute to 'true'.
   * If false, removes the aria-hidden attribute.
   */
  setAriaHidden(isHidden: boolean): this;
}

interface ISingleElementHandler extends IAttributeHandler {
  /**
   * Sets the focus on the element(s).
   * @param shouldFocus If true, focuses the element; if false, blurs it.
   * If not provided, defaults to true (focuses the element).
   */
  setFocus(shouldFocus?: boolean): this;
}

interface IMultipleElementHandler extends IAttributeHandler {}
